<template>
  <v-card>
    <v-tabs
      v-model="active"
      background-color="#e7f8ff"
      grow
      show-arrows
      color="hrissecondary"
    >
      <v-tab
        v-for="item in filteredTabItems"
        :key="item.name"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items 
      v-model="active"
    >
      <v-tab-item
        v-if="$hasPermissionTo(['view claim approval workflows'])"
        class="pb-12"
      >
        <setup-claims-approval-workflow-overview-container-view
          :claim-approval-workflow-batch="claimApprovalWorkflowBatch"
        />
      </v-tab-item>
      <v-tab-item
        v-if="$hasPermissionTo(['view claim assignees'])"
        class="pb-12"
      >
        <setup-claims-approval-workflow-claim-assignee-container-view
          :claim-approval-workflow-batch="claimApprovalWorkflowBatch"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
  export default {
    components: {
      SetupClaimsApprovalWorkflowOverviewContainerView: () => import('@/components/hris/setup/claims/approval-workflow/overview/ContainerView'),
      SetupClaimsApprovalWorkflowClaimAssigneeContainerView: () => import('@/components/hris/setup/claims/approval-workflow/claim-assignee/ContainerView'),
    },
    props: {
      claimApprovalWorkflowBatch: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view claim approval workflows'])) {
          modifiedTab.push({ name: 'Overview' })
        }
 
        if (this.$hasPermissionTo(['view claim assignees'])) {
          modifiedTab.push({ name: 'Claim Assignees' })
        }

        return modifiedTab
      },
    },
  }
</script>
